import { render, staticRenderFns } from "./game-form-page-teams.vue?vue&type=template&id=14bafe24&scoped=true&"
import script from "./game-form-page-teams.vue?vue&type=script&lang=js&"
export * from "./game-form-page-teams.vue?vue&type=script&lang=js&"
import style0 from "./game-form-page-teams.vue?vue&type=style&index=0&id=14bafe24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bafe24",
  null
  
)

export default component.exports